import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'normalizeText' })
export class NormalizeTextPipe implements PipeTransform {

  /* transform(): Pipe que elimina las tildes y similares de un texto
    value: Texto a formatear
  */
  transform = (value: string): string => (value || '').normalize('NFD').replace(/([^n\u0300-\u036f]|n(?!\u0303(?![\u0300-\u036f])))[\u0300-\u036f]+/gi, "$1");

}
